import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, TravelSimulateAllResponseDto } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ISimulateTravelCommandParameters } from "./simulateTravel.command";

export class SimulateAllTravelCommand extends IRequestCommand<
  ISimulateAllTravelResponse,
  ErrorDetails,
  ISimulateTravelCommandParameters
> {
  override _commandType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierUserId}/travels/simulateAll';
  public override setParameters(parameters: ISimulateTravelCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface ISimulateAllTravelResponse
  extends TravelSimulateAllResponseDto,
    ICommandResponse {}
